import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import App from 'offshore_pcb/App';
import Cart from 'offshore_pcb/Cart';
import store from 'offshore_pcb/store';

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.getElementById('quote-form');
  const cartContainer = document.getElementById('cart-form');

  if (appContainer != null) {
    render(
      <Provider store={store}>
        <App />
      </Provider>,
      appContainer,
    );
  }

  if (cartContainer) {
    render(
      <Provider store={store}>
        <Cart />
      </Provider>,
      cartContainer,
    );
  }
});
